// TODO: export these constants
/** @hidden */
export var GRID_ROW_INDEX_ATTRIBUTE = 'data-grid-row-index';
/** @hidden */
export var GRID_COL_INDEX_ATTRIBUTE = 'data-grid-col-index';
//# sourceMappingURL=index.js.map